import React from 'react';
import './CarImageComponent.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuMousePointerClick } from "react-icons/lu";
const CarImageComponent = () => {
  const navigate = useNavigate(); // Get the navigate function

  const [activeButton, setActiveButton] = useState(null);
  
  const handleButtonClick = (button) => {
    setActiveButton(button);
    console.log(`${button} clicked`);
    if (button==="Get a Quote"){
      navigate("/subcontractform")
    }
    if (button==="Drive For Us"){
      navigate("/DriveDetail")
    }
    if (button==="Contact US"){
      navigate("/LogisticContact")
    }
    if (button==="Login"){
      navigate("/Logistics/Login")
    }

  };

  return (
    <div className="car-image-container">
      <div className="contentcarimage">
        
        <h1 style={{fontSize:'2rem', color:'white'}}><strong>Move your car in 2 clicks</strong>  <LuMousePointerClick style={{ color: 'red' }} /></h1>
        <h1 className="heading" style={{color:'red'}}>Welcome To Zoom Autos</h1>
        <h2 style={{color:'white'}}>Your Trusted Logistics Partner</h2>
        <p className="description">Get your car delivered on your door step</p>
        
        <div style={{display:"flex",justifyContent:"center", width:'100%'}}>
        <div className="buttonm-bar">
      {["Get a Quote", "Drive For Us", "Contact US","Login"].map((button) => (
        <button
          key={button}
          type="button"
          className={`buttonm ${activeButton === button ? "active" : ""}`}
          onClick={() => handleButtonClick(button)}   
        >
          {button}
        </button>
      ))}
            </div>
            </div>
      </div>
      {/* <img
        src={ford2}
        alt="Car"
        className="car-image"
      /> */}
    </div>
  );
};

export default CarImageComponent;
